(function($) {

    $.fn.mainNav = function() {

        var overlay = $('.js-site-nav__overlay');

        var init = function() {

            var allowableBreakpoints = ['desk', 'desk-wide'],
                currentBreakpoint = $.getBreakpoint();

            // if current breakpoint is not in allowableBreakpoints, do nothing
            if (allowableBreakpoints.indexOf(currentBreakpoint) < 0) {
                return;
            }

            // else, continue...

            // On touch/hover of nav toggle button...
            $('.js-site-nav__link').on('mouseenter touchstart', function(evt) {

                var link = $(this),
                    navItem = link.parent(),
                    hasDropdown = link.siblings('.js-site-nav__sub-nav').length > 0;

                // If this link has a dropdown
                if(hasDropdown) {

                    // If the dropdown is already open, allow the touch event to continue
                    if( navItem.hasClass('is-active') ) {
                        return true;
                    }

                    evt.preventDefault();

                    // Hide all dropdowns
                    $('.js-site-nav__item').removeClass('is-active');

                    // Reveal this dropdown
                    navItem.addClass('is-active');

                    // Reveal the overlay
                    overlay.addClass('is-active');
                }
            });

            // On click of overlay
            overlay.on('mouseenter touchstart', function(evt) {
                // Hide all dropdowns
                $('.js-site-nav__item').removeClass('is-active');

                // Hide the overlay
                overlay.removeClass('is-active');
            });

        };

        init();
        return this;
    };

}($));
